import {Component} from '@angular/core';

@Component({
  template: `
    <router-outlet></router-outlet>
  `
})

export class LocationComponent {
 constructor() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/location/location.component.ts